export enum FilterTypesEnum {
    AssetStatus,
    Customer,
    Poc,
    Order
}
